var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("router-link", {
    attrs: { to: _vm.inboxPage, custom: true },
    scopedSlots: _vm._u(
      [
        {
          key: "default",
          fn: function ({ href, navigate }) {
            return [
              _c(
                "a",
                {
                  attrs: { href: href },
                  on: {
                    click: function ($event) {
                      return _vm.onLinkClick($event, navigate)
                    },
                  },
                },
                [
                  _vm._t("default", function () {
                    return [
                      _c("ChatIcon", {
                        staticClass:
                          "h-5 w-5 mt-0.5 text-icon-primary fill-icon-primary hover:fill-icon-primary-hover",
                      }),
                    ]
                  }),
                ],
                2
              ),
            ]
          },
        },
      ],
      null,
      true
    ),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }